import axios from 'axios';
import {getGuestsWithAttendees} from "../server/Api";

export const getMainGuestsAndAttendees = async (eventId) => {
  if (!eventId) throw new Error("eventId is required");

  try {
    const response = await axios.get(getGuestsWithAttendees(eventId));
    return response.data.data; // Assuming your API response is { data: [...] }
  } catch (error) {
    console.error("Error fetching guests:", error);
    throw error; // Let the caller handle error (e.g., toast in component)
  }
};